import type { Dimension, VectorFor } from "@src/math/types";
import type { EquationEvaluation } from "../equation";
import { transform } from "@src/math/matrix";

export function getTransformedVectors<D extends Dimension>(
  evaluation: EquationEvaluation<D>,
): VectorFor<D>[] {
  return evaluation.vectors.map((vector) =>
    transform(
      evaluation.dimension,
      evaluation.totalTransform,
      vector.coordinates,
    ),
  );
}
